import {
  type QueryKey,
  keepPreviousData,
  useQuery,
} from '@tanstack/react-query';
import { Context, SearchType, gqlClient, graphql } from '@tyro/api';
import { useTranslation } from '@tyro/i18n';

const studentsSearch = graphql(/* GraphQL */ `
  query studentsSearchQuery($filter: SearchFilter) {
    search_search(filter: $filter) {
      partyId
      type
      text
      avatarUrl
    }
  }
`);

export function useStudentsSearch(query: string, queryKey: QueryKey) {
  const { t } = useTranslation(['common']);
  const trimmedQuery = query.trim();

  return useQuery({
    queryKey,
    queryFn: async () =>
      gqlClient.request(studentsSearch, {
        filter: {
          text: trimmedQuery,
          context: [Context.Party],
          includeSearchType: [
            SearchType.Student,
            SearchType.GeneralGroup,
            SearchType.SubjectGroup,
            SearchType.YearGroupEnrollment,
            SearchType.CustomGroup,
          ],
        },
      }),
    enabled: trimmedQuery.length > 0,
    placeholderData: keepPreviousData,
    select: ({ search_search }) =>
      search_search.map((student) => ({
        ...student,
        firstName: student.text,
        caption: student.type ? t(`common:searchType.${student.type}`) : '',
      })),
  });
}
